export const UNKNOWN_ERROR = 'Неизвестная ошибка';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type SafeError = Error | string | { message: string } | typeof UNKNOWN_ERROR;

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export function getErrorMsg(error: SafeError | unknown): string {
  let errorMessage = UNKNOWN_ERROR;

  if (error === undefined) {
    return errorMessage;
  }

  if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'object' && error !== null && 'message' in error) {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === 'string') {
      errorMessage = maybeMessage;
    }
  }

  return errorMessage;
}
